import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Modal, Table, Breadcrumb } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import "react-data-table-component-extensions/dist/index.css";
import moment from 'moment';
import { getRoles } from '../../utils/swtAlert';
import { Decrypt } from '../../utils/Helper';
import { GrokLoading } from "../page-layout/loading/Loading";
import { GetCompanyReport } from "../../utils/axios/ReportsAPI";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import { GetCompanyParticipants } from '../../utils/axios/ReportsAPI';

const GroupByCompany = () => {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [anotherloading, setAnotherLoading] = useState(true);
    const [role, setRole] = useState('');
    const [CompanyParticipants, setCompanyParticipants] = useState([]);
    const [ChallengesData, setChallengesData] = useState('');
    const [data, setData] = useState();

    //For Datatable Expand rows
    const [expandedRows1, setExpandedRows1] = useState(null);

    const columns = [
        {
            name: "Industry Partner",
            selector: row => row.companyName,
            sortable: true,
            cell: row => row.companyName,
        },
        {
            name: "Total Industry Use Caese Posted",
            selector: row => row.challengeCount,
            sortable: true,
            cell: row => row.challengeCount,
        },
        {
            name: "Participation",
            width: "150px",
            cell: (row) => (<>
                {row.challengeCount == 0 ? <button className="btn btn-link" title="Participant Details" disabled onClick={() => handleShowParticipants(row.companyId)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><circle cx="152" cy="184" r="72"></circle><path d="M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"></path><path d="M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"></path><circle cx="340" cy="168" r="88"></circle></svg></span></button> :
                    <button className="btn btn-link" title="Participant Details" onClick={() => handleShowParticipants(row.companyId)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><circle cx="152" cy="184" r="72"></circle><path d="M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"></path><path d="M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"></path><circle cx="340" cy="168" r="88"></circle></svg></span></button>}
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            omit: (role == "Student") ? true : false
        },
    ]
    const tableData = {
        print:false,
        export:false,
        columns,
        data,
    };

    const BackBtn = () => {
        navigate('/home');
    }

    const addRefresh = () => {
        navigate('/home', {state: {companyid: null}});
    }

    const [showParticipants, setShowParticipants] = useState(false);
    const handleCloseParticipants = () => {
        setShowParticipants(false);
        setCompanyParticipants("");
        setChallengesData("");
    }
    const handleShowParticipants = async (companyId) => {
        setAnotherLoading(true);
        setShowParticipants(true);
        setExpandedRows1(null);
        if (companyId) {
            let companydetailspayload = {
                organizationId: companyId
            }
            var companydetailResponse = await GetCompanyParticipants(companydetailspayload)
            if (companydetailResponse.challengeData) {
                setLoading(false);
                setChallengesData(companydetailResponse?.organizationName || '');
                setCompanyParticipants(companydetailResponse.challengeData);
                setAnotherLoading(false);
            }
        }
        else {

        }
    }

    const getcompanyreport = async () => {
        var organizationResponse = await GetCompanyReport();
        setData(organizationResponse.data);
        if (organizationResponse) {
            setLoading(false);
        }
    }

    const handleRowExpand1 = (userID) => {
        let currentExpandedRows = null;
        const isRowExpanded = currentExpandedRows === userID ? userID : null;
        const newExpandedRows = isRowExpanded
            ? null
            : (currentExpandedRows = userID);
        if (expandedRows1 !== userID) {
            setExpandedRows1(newExpandedRows);
        }
        else {
            setExpandedRows1(null);
        }
    };

    useEffect(() => {
        getcompanyreport();
        const role = getRoles(userInfo);
        setRole(role);
        setTimeout(() => {
            if (role === 'Grok Admin') { //Grok Admin
                document.getElementById('nav-dropdownReport').parentElement.classList.add('show');
                document.getElementById('nav-dropdownReport').nextSibling.classList.add('show');
            }
            else {
                // Error handler
            }

        }, 300);
    }, [])


    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active> GroupByIndustryPartner</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='Company'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" aria-hidden="true" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 2.25a.75.75 0 000 1.5v16.5h-.75a.75.75 0 000 1.5H15v-18a.75.75 0 000-1.5H3zM6.75 19.5v-2.25a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75zM6 6.75A.75.75 0 016.75 6h.75a.75.75 0 010 1.5h-.75A.75.75 0 016 6.75zM6.75 9a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM6 12.75a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 6a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zm-.75 3.75A.75.75 0 0110.5 9h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zM10.5 12a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM16.5 6.75v15h5.25a.75.75 0 000-1.5H21v-12a.75.75 0 000-1.5h-4.5zm1.5 4.5a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008zm.75 2.25a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75v-.008a.75.75 0 00-.75-.75h-.008zM18 17.25a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z" clipRule="evenodd"></path></svg></span>
                                </Button>
                                <h2 className="page-title">Group By Industry Partner</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3 mt-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='taablist'>
                                <div >
                                    <DataTableExtensions {...tableData}  >
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            fixedHeader
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationPerPage={20}
                                            paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                        />
                                    </DataTableExtensions>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <Modal show={showParticipants} onHide={handleCloseParticipants} size="xl" backdrop="static" keyboard={false} className="model-popup" dialogClassName="modal-90w modal_report" centered>
                            {anotherloading ? <GrokLoading /> : ""}
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title"><b>Group By Company</b> </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>

                                <div className='challenge_detail_style mb-3 d-flex bold'>
                                    <h5 className='mx-2 mt-1'>{ChallengesData}</h5>
                                </div>
                                <div style={{ maxHeight: '530px', overflowY: 'auto' }}>
                                    <Table striped bordered hover responsive>
                                        <thead className='fw-bold'>
                                            <tr>
                                                <th>Action</th>
                                                <th>Challenge Title</th>
                                                <th>College Count</th>
                                            </tr>
                                        </thead>
                                        <tbody className='my-table'>
                                            {CompanyParticipants && CompanyParticipants.map((challenges, studentIndex) => (
                                                <React.Fragment key={studentIndex}>
                                                    {/* {studentIndex === 0 && ( */}
                                                    <tr className='my-tables'>
                                                        <td key={challenges['Challenge Id']} value={challenges['Challenge Id']}>
                                                            {challenges['College Count'] == 0 ?
                                                                (<button className='btn newBtn_style' variant="dark" title="Expand" disabled onClick={() => handleRowExpand1(studentIndex)}>
                                                                    <svg width="12px" height="12px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M19 5L12.7071 11.2929C12.3166 11.6834 11.6834 11.6834 11.2929 11.2929L5 5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M19 13L12.7071 19.2929C12.3166 19.6834 11.6834 19.6834 11.2929 19.2929L5 13" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </button>) : (<button className='btn newBtn_style' title="Expand" onClick={() => handleRowExpand1(studentIndex)}>
                                                                    <svg width="12px" height="12px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M19 5L12.7071 11.2929C12.3166 11.6834 11.6834 11.6834 11.2929 11.2929L5 5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M19 13L12.7071 19.2929C12.3166 19.6834 11.6834 19.6834 11.2929 19.2929L5 13" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </button>)}
                                                        </td>
                                                        <td className='text-nowrap'>
                                                            {challenges['Challenge Name']}
                                                        </td>
                                                        <td className='text-nowrap'>
                                                            {challenges['College Count']}
                                                        </td>
                                                    </tr>
                                                    {expandedRows1 == studentIndex ?
                                                        <tr>
                                                            <td colSpan="3" className="collaps-viewer">
                                                                <div style={{ textAlign: "center", width: "100%" }}>
                                                                    <Table className='tableexpandeds mx-auto'>
                                                                        <thead>
                                                                            <tr>
                                                                                <th id='participatedCollege'>College</th>
                                                                                <th id='participatedCollege'>Student Name</th>
                                                                                <th id='participatedCollege' >Semester</th>
                                                                                <th id='participatedCollege' >Year</th>
                                                                                <th id='participatedCollege' >Branch</th>
                                                                            </tr>
                                                                        </thead>

                                                                        {challenges && challenges.colleges.map((college, index) => (
                                                                            <tbody className='my-table' key={index}>
                                                                                {college && college.studentData.map((student, studentIndex) => (
                                                                                    <React.Fragment key={studentIndex}>
                                                                                        {studentIndex === 0 && (
                                                                                            <tr>
                                                                                                <td className='text-nowrap' rowSpan={college.studentData.length}>
                                                                                                    {college['College Name']}
                                                                                                </td>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.studentName}
                                                                                                </td>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.semesterName}
                                                                                                </td>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.yearName}
                                                                                                </td>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.branchName}
                                                                                                </td>
                                                                                            </tr>
                                                                                        )}
                                                                                        {studentIndex !== 0 && (
                                                                                            <tr>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.studentName}
                                                                                                </td>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.semesterName}
                                                                                                </td>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.yearName}
                                                                                                </td>
                                                                                                <td className='text-nowrap'>
                                                                                                    {student.branchName}
                                                                                                </td>
                                                                                            </tr>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                ))}
                                                                            </tbody>
                                                                        ))}
                                                                    </Table>
                                                                </div>
                                                            </td>
                                                        </tr> : null}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default GroupByCompany; 